import { ITrackAreaItem } from '../interfaces/ITrackAreaItem';
import { Track } from './Track';
import { IDataTrackAreaItem } from '../redux/timeline-data.model';

class TrackGroup implements ITrackAreaItem {
	id: string;
	private _tracks: ITrackAreaItem[];
	private _data: IDataTrackAreaItem;

	constructor( data: IDataTrackAreaItem ) {
		if ( data != null && data.id != null ) {
			this.id = data.id;
			this.update( data );
		}
	}

	get tracks(): ITrackAreaItem[] {
		return this._tracks;
	}

	set tracks(tracks: ITrackAreaItem[]) {
		this._tracks = tracks;
	}

	get label(): string {
		return this._data.label;
	}

	public update( data: IDataTrackAreaItem ): void {
		this._data = data;
		this._tracks = [];
		if ( data && data.tracks) {
			const datatracks: IDataTrackAreaItem[] = data.tracks; // NB 'tracks' doesn't exist?!?
			for ( let i = 0, l: number = datatracks.length; i < l; i++ ) {
				let newItem: ITrackAreaItem;
				if ( datatracks[i].type === 'track' ) {
					newItem = new Track( datatracks[i] );
				} else if ( datatracks[i].type === 'trackgroup' ) {
					newItem = new TrackGroup( datatracks[i] );
				}
				if ( newItem ) {
					this._tracks.push( newItem );
				}
			}
		}
	}
}

export { TrackGroup };
